import { getEnumTranslationMap } from '../utils/get-enum-translation-map';

export enum Currency {
    EUR = 'EUR',
    CHF = 'CHF',
}

export const currencyTranslationMap = getEnumTranslationMap(Currency);
